import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
export const GET_ASSOCIATION_DEFINITION = 'campaignsPlatformComponentsAssociationDefinition';
const QUERY_ASSOCIATION_DEFINITION = registerQuery({
  fieldName: GET_ASSOCIATION_DEFINITION,
  args: ['associationId'],
  fetcher({
    associationId
  }) {
    return http.post('associations/v1/definitions/batch', {
      data: [{
        associationCategory: 'HUBSPOT_DEFINED',
        associationTypeId: associationId
      }]
    }).then(res => {
      if (res.length) {
        return res[0];
      }
      return undefined;
    });
  }
});
export const useFetchAssociationDefinition = ({
  associationSettings,
  objectType
}) => {
  var _associationSettings$;
  const associationIdFromSettings = associationSettings === null || associationSettings === void 0 || (_associationSettings$ = associationSettings[objectType]) === null || _associationSettings$ === void 0 || (_associationSettings$ = _associationSettings$.campaignsAssociations) === null || _associationSettings$ === void 0 || (_associationSettings$ = _associationSettings$.metadata) === null || _associationSettings$ === void 0 || (_associationSettings$ = _associationSettings$.associationId) === null || _associationSettings$ === void 0 ? void 0 : _associationSettings$.value;
  const {
    data,
    loading,
    error
  } = useQuery(QUERY_ASSOCIATION_DEFINITION, {
    variables: {
      associationId: associationIdFromSettings
    },
    skip: !associationIdFromSettings
  });
  return {
    data: data === null || data === void 0 ? void 0 : data[GET_ASSOCIATION_DEFINITION],
    loading,
    error
  };
};